<form [formGroup]="form" (ngSubmit)="submitForm()">
  <title mat-dialog-title>{{ 'common.password' | t }}</title>
  <mat-dialog-content>
    <mat-progress-bar
      mode="indeterminate"
      color="accent"
      class="progress-bar-spacing"
      *ngIf="!rules.length && isLoading"
    >
    </mat-progress-bar>
    <div>
      <ul class="password-rules-list" *ngIf="rules?.length && !isLoading">
        <li *ngFor="let rule of rules">{{ rule | t }}</li>
      </ul>
    </div>
    <div>
      <ul class="password-rules-list" *ngIf="!rules.length && !isLoading">
        <li>Must not be similar to user email or name.</li>
        <li>Must be at least 6 characters long.</li>
        <li>Must not be a common password.</li>
        <li>Must not be entirely numeric.</li>
        <li>Must not be entirely numeric.</li>
      </ul>
    </div>
    <sn-form [form]="form" [fields]="formFields" [(model)]="formModel"></sn-form>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-button type="button" color="danger" (click)="cancel()">{{ 'common.cancel' | t }}</button>
    <button
      mat-button
      type="submit"
      color="success"
      [mtBasicSpinner]="isLoading"
      [disabled]="form.invalid"
    >
      {{ 'common.change' | t }}
    </button>
  </mat-dialog-actions>
</form>
